export const WHICH_TIMMY = 'whichTimmy'